export type QuoteNumberRule =
  | "nonnegative"
  | "positive"
  | "nonnegative-integer"
  | "positive-integer";
export function parseQuoteNumberText(
  raw: string,
  rule: QuoteNumberRule = "nonnegative",
): number | null {
  const normalized = raw
    .replace(/[！-～]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/\u3000/g, " ")
    .trim();
  // 只去掉合法的千分位分隔符，不能把 1,2 或 1,,000 猜成另一个数。
  const text = /^[+-]?\d{1,3}(?:,\d{3})+(?:\.\d*)?(?:[eE][+-]?\d+)?$/.test(
    normalized,
  )
    ? normalized.replace(/,/g, "")
    : normalized;
  const integer = rule.endsWith("integer");
  if (
    !(
      integer ? /^[+-]?\d+$/ : /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/
    ).test(text)
  )
    return null;
  const value = Number(text);
  if (
    !Number.isFinite(value) ||
    value < 0 ||
    (rule.startsWith("positive") && value <= 0) ||
    (integer && !Number.isSafeInteger(value))
  )
    return null;
  return value === 0 ? 0 : value;
}

/** 本地表单复用完整解析；选填留空才省略，非法/越界不冒充缺省。 */
export function readQuoteNumberInput(
  raw: string,
  spec: {
    label: string;
    rule: QuoteNumberRule;
    optional?: boolean;
    max?: number;
  },
): { value: number | undefined; problem: string | null } {
  if (spec.optional && raw.trim() === "")
    return { value: undefined, problem: null };
  const value = parseQuoteNumberText(raw, spec.rule);
  if (value !== null && (spec.max === undefined || value <= spec.max))
    return { value, problem: null };
  const kind = spec.rule.endsWith("integer") ? "整数" : "数值";
  const lower = spec.rule.startsWith("positive") ? "大于 0" : "不小于 0";
  return {
    value: undefined,
    problem: `${spec.label}请填写${lower}的${kind}${spec.max === undefined ? "" : `，且不能超过 ${spec.max}`}`,
  };
}
